<h2 mat-dialog-title>{{ dialogData.title | translate }}</h2>
<mat-dialog-content>
  {{ dialogData.text | translate }}
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">{{ dialogData.labelCancel | translate}}</button>
  <button mat-button [mat-dialog-close]="true">{{ dialogData.labelConfirm| translate}}</button>
</mat-dialog-actions>
